import { render, staticRenderFns } from "./PreviewColumnElement.vue?vue&type=template&id=d061530e&"
import script from "./PreviewColumnElement.vue?vue&type=script&lang=js&"
export * from "./PreviewColumnElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports